import * as React from "react";
import * as classNames from "classnames";

export enum FontSize {
    FourX = 'fa-4x',
    TwoX = 'fa-2x',
    OneX = 'fa-1x',
}

interface LoadingWithMessageProps {
    message: string;
    size?: FontSize;
}

export default class LoadingWithMessage extends React.Component<LoadingWithMessageProps> {
    static defaultProps = {
        size: FontSize.FourX
    }

    constructor(props: LoadingWithMessageProps) {
        super(props);
    }

    render() {
        const classes = classNames("fas", "fa-circle-notch", "fa-spin", "text-info", this.props.size);

        return (
            <div data-automationid="loadingIndicator">
                <br />
                <p style={{ fontSize: 3 + "rem" }} className="text-center text-info">
                    <i className={classes} aria-hidden="true" />
                </p>
                <p className="text-center">{this.props.message}</p>
            </div>
        );
    }
}
